import { useConfiguracoes } from 'hooks/configuracoes'
import { parseVersionFollowingSemVer } from 'util/string/string-parseVersion'

import { NewsTopicsLinkList } from '../components/NewsTopicsLinkList'
import useNewsItems, { NewsVersion } from '../hooks/useNewsItems'

type NewsModalBodyLinksProps = {
  onLinkClick?: () => void
}

export function NewsModalBodyLinks({ onLinkClick }: Readonly<NewsModalBodyLinksProps>) {
  const newsItems = useNewsItems()

  const {
    configuracoes: { versao },
  } = useConfiguracoes()

  const { major, minor } = parseVersionFollowingSemVer(versao)
  const currentVersionFormattedKey = `${major}-${minor}`

  const mostRecentTopics = newsItems[currentVersionFormattedKey].topics

  return (
    <NewsTopicsLinkList
      version={currentVersionFormattedKey as NewsVersion}
      topics={mostRecentTopics}
      onLinkClick={onLinkClick}
    />
  )
}
